export default __webpack_public_path__ + "static/media/chevrons-sidebar.a90f53e7.svg";